import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import HeaderBack from "@/components/dashboard/Header/HeaderBack";

import MotionText from '@/components/common/Motion/MotionText';
import ButtonLink from "@/components/common/Button/ButtonLink";
import Button from '@/components/common/Button/Button';

import { useNavigate } from 'react-router-dom';

export const BoltBlockedPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();

  return (
    <div className="h-full bg-white flex flex-col">
      <HeaderBack to="/" />
      <div className="flex flex-col px-5 pb-[10rem]">
        <MotionText
          as='h1'
          className='font-semibold text-3xl mb-4'>
            {t('bolt.blocked.title')}
        </MotionText>
        <MotionText
          as='p'
          className='text-base text-zinc-700 mb-4'
        >
          {t('bolt.blocked.description')}
        </MotionText>
        <motion.div
          className="absolute bottom-0 -ml-5 px-5 pb-4 pt-8 w-full bg-linear-to-t from-white via-white to-transparent from-0% via-40% to-100%"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink
            target='_blank'
            to={'https://bolt.eu/lt-lt/support/articles/4402862523666'}
            variant='primary'
            className='mb-4 w-full h-[3rem]'
          >
            {t('bolt.blocked.contactBolt')}
          </ButtonLink>
          <Button
            onClick={() => navigate(-1)}
            variant='secondary'
            className='mb-4 w-full h-[3rem]'
          >
            <span>{t('common.goBack')}</span>
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

export default BoltBlockedPage;